import Error from "../Layouts/Error"
import Loading from "../Layouts/Loading"
import { MediaRequest, useDeleteMediaMutation, useGetAllMediaQuery, useUploadMediaMutation } from "../Redux/Apis/mediaApi"
import { fa_date, fa_number } from "../utils/Persian"
import React, { useState } from "react"

interface MediaGalleryProps {
    isOpen: boolean;
    onClose: () => void;
    onImageSelect: (imageUrl: string) => void;
  }

const MediaGallery: React.FC<MediaGalleryProps> = ({isOpen,onClose,onImageSelect,}) => {
    const [deleteMedia] = useDeleteMediaMutation()
    const [errorMsg, setErrorMsg] = useState<any>(false)
    const [upload, { isLoading : isLoadingMedia }] = useUploadMediaMutation()
    const [formState, setFormState] = useState<MediaRequest>({
        name: '',
        title: '',
        type: 'image',
        image: null,
    })

    const reset = () => {
        setFormState({
            name: '',
            title: '',
            type: 'image',
            image: null,
        });

        const input = (document.getElementById("formFile") as HTMLInputElement)
        if (input) input.value = ''
    }
    
    const handleChange = ({ target: { name, value , files },} : React.ChangeEvent<HTMLInputElement> ) =>
        setFormState((prev) => (name === 'image' ? { ...prev, [name]: files ? files[0] : null } : { ...prev, [name]: value }))

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            const form = new FormData(); 
            form.append('image',formState.image)
            form.append('name',formState.name)
            form.append('type',formState.type)
            if (formState.title) form.append('title',formState.title)
            await upload(form).unwrap()
            reset();
            setErrorMsg(false)
        } catch (err:any){
            // console.log(err);
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetAllMediaQuery({})

    if (!isOpen) return null;

    const handleImageClick = (url: string): void => {
        onImageSelect(url);
        onClose();
    };

    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error data={error}/>

    else if(isSuccess) {
        return(
            <div className="modal fade show" style={{display: "block",backgroundColor: "rgba(0, 0, 0, 0.5)"}} id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="staticBackdropLabel">مدیا گالری</h1>
                        <button type="button" onClick={() => {reset();onClose()}} className="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeModal"></button>
                    </div>
                    <div className="modal-body">
                        {errorMsg && <div className="alert alert-danger" role="alert">
                            {errorMsg}
                        </div>}

                        <form className="row row-cols-lg-auto g-3 align-items-center p-2 mt-2 mb-4 border border-primary-subtle rounded" id="mediaForm" onSubmit={onSubmit}>
                            <div className="col-12 mt-0">
                                <label htmlFor="formFile" className="visually-hidden">تصویر</label>
                                <input className="form-control" type="file" onChange={handleChange} name="image" id="formFile"/>
                            </div>
                            <div className="col-12 mt-0">
                                <label htmlFor="media_name" className="visually-hidden"><i className="zmdi zmdi-account me-1"></i>نام تصویر</label>
                                <input className="form-control" type="text" value={formState.name} onChange={handleChange} name="name" id="media_name" placeholder="نام تصویر"/>
                            </div>
                            <div className="col-12 mt-0">
                                <label htmlFor="media_title" className="visually-hidden"><i className="zmdi zmdi-account me-1"></i>نام فارسی</label>
                                <input className="form-control" type="text" value={formState.title} onChange={handleChange} name="title" id="media_title" placeholder="نام فارسی (*سئو)"/>
                            </div>
                            <div className="col-12 mt-0">
                                <button type="submit" form='mediaForm' disabled={isLoadingMedia} className="btn btn-primary">آپلود جدید</button>
                            </div>
                        </form>

                        <div className="row row-cols-1 row-cols-lg-5 row-cols-md-4 row-cols-sm-3 row-cols-xs-2 g-4">
                            {data && data.length > 0 ? data.map((value:any,index:number) => 
                            <div className="col" key={index}>
                                <div className="card">
                                    <img className="card-img-top" src={value.url} alt={value.title}/>
                                    <div className="card-body">
                                        <h5 className="card-title">{value.title}</h5>
                                        <div className="card-text">
                                            <p>
                                            تاریخ ایجاد:
                                            <small className="ms-1">{fa_date(value.create_date)}</small>
                                            </p>
                                            <p>
                                                سایز: 
                                                <small className="ms-1">{fa_number( value.size) + " "} 
                                                مگابایت  
                                                </small>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="card-footer text-end">
                                        <button type="button" onClick={() => handleImageClick(value.url)} className="btn btn-primary float-end">انتخاب</button>
                                        <button type="button" onClick={() => window.confirm('آیا از حذف این تصویر اطمینان دارید؟') && deleteMedia(value.id)}  className="btn btn-link text-danger float-start">حذف</button>
                                    </div>
                                </div>
                            </div>
                            ) : 
                            <div className="alert alert-secondary" role="alert">تصویری موجود نیست...</div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    else return <></>
}

export default MediaGallery;